//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex';
import { replaceSpecialCharacters } from '~/utils';

export default {
  name: 'BrowseCard',
  props: {
    item: { type: Object, default: () => {} },
  },
  methods: {
    ...mapActions('jobs', ['setCurrentJobId']),
    gotoJobsContent(item) {
      this.setCurrentJobId(item.id || 0);
      this.$router.push({
        path: `/JobsContent/${item.id}-${replaceSpecialCharacters(item.title)}`,
        query: { id: item.id },
      });
    },
    deleteBrowse(id, title) {
      this.$confirm(`是否刪除 ${title} 瀏覽紀錄？`, '提示', {
        type: 'warning',
      }).then(() => {
        this.$api('removeUserBrowseHistory', { id }).then(data => {
          this.$message.success('刪除瀏覽紀錄成功!');
          this.$emit('update');
        });
      });
    },
  },
};
